module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "rockArtForm",
      "id": "rockArtForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('h4', [_vm._v("Panel " + _vm._s(_vm.rockArtPanelDto.panelNumber) + " of " + _vm._s(_vm.rockArtCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Panel ID:")]), _vm._v(" " + _vm._s(_vm.rockArtPanelDto.dbNumber) + "\n                ")])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Production Panel Selection:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qaqcSelection.panelSelection),
      expression: "qaqcSelection.panelSelection"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.qaqcSelection, "panelSelection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": -1
    }
  }, [_vm._v("Panel Selection")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Add As New Production Panel")]), _vm._v(" "), _vm._l((_vm.productionPanelList), function(panel) {
    return _c('option', {
      domProps: {
        "value": panel.rockArtPanelId
      }
    }, [_vm._v("Update Production Panel: " + _vm._s(panel.dbNumber))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.panelAge')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Presumed Age")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rockArtPanelDto.panelAgeId),
      expression: "rockArtPanelDto.panelAgeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "panelAge"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rockArtPanelDto, "panelAgeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.ageList), function(age) {
    return _c('option', {
      domProps: {
        "value": age.panelAgeId
      }
    }, [_vm._v("\n                            " + _vm._s(age.description) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.panelAge')),
      expression: "errors.has('rockArtForm.panelAge')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.panelAge')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'panelAgeId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.panelLocation')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rockArtPanelDto.panelLocationId),
      expression: "rockArtPanelDto.panelLocationId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "panelLocation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rockArtPanelDto, "panelLocationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.locationList), function(location) {
    return _c('option', {
      domProps: {
        "value": location.panelLocationId
      }
    }, [_vm._v("\n                            " + _vm._s(location.description) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.panelLocation')),
      expression: "errors.has('rockArtForm.panelLocation')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.panelLocation')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'panelLocationId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.placementDescription')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Placement and Distance")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.placementDescription),
      expression: "orientationDto.placementDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description of Placement and Distance to Surrounding Panels",
      "name": "placementDescription"
    },
    domProps: {
      "value": (_vm.orientationDto.placementDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "placementDescription", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.placementDescription')),
      expression: "errors.has('rockArtForm.placementDescription')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.placementDescription')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'placementDescription',
      "hasAppend": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.rockType')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Rock Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.rockType),
      expression: "orientationDto.rockType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type of Rock and geological formation",
      "name": "rockType"
    },
    domProps: {
      "value": (_vm.orientationDto.rockType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "rockType", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.rockType')),
      expression: "errors.has('rockArtForm.rockType')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.rockType')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'rockType',
      "hasAppend": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.panelAspect')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Panel Aspect")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.panelAspectId),
      expression: "orientationDto.panelAspectId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "panelAspect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.orientationDto, "panelAspectId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.compassBearingList), function(bearing) {
    return _c('option', {
      domProps: {
        "value": bearing.panelAspectId
      }
    }, [_vm._v("\n                            " + _vm._s(bearing.description) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.panelAspect')),
      expression: "errors.has('rockArtForm.panelAspect')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.panelAspect')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'panelAspectId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.eastDegree')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Panel Degrees")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.eastDegree),
      expression: "orientationDto.eastDegree"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "eastDegree"
    },
    domProps: {
      "value": (_vm.orientationDto.eastDegree)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "eastDegree", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.eastDegree')),
      expression: "errors.has('rockArtForm.eastDegree')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.eastDegree')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'eastDegree',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': (_vm.errors.has('rockArtForm.heightBottom') || _vm.errors.has('rockArtForm.heightTop'))
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Height")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group form-inline"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.heightBottom),
      expression: "orientationDto.heightBottom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": "Lowest",
      "name": "heightBottom"
    },
    domProps: {
      "value": (_vm.orientationDto.heightBottom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "heightBottom", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.heightTop),
      expression: "orientationDto.heightTop"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": "Highest",
      "name": "heightTop"
    },
    domProps: {
      "value": (_vm.orientationDto.heightTop)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "heightTop", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.errors.has('rockArtForm.heightBottom') || _vm.errors.has('rockArtForm.heightTop'))),
      expression: "(errors.has('rockArtForm.heightBottom') || errors.has('rockArtForm.heightTop'))"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'heightBottom',
      "hasAppend": false
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': (_vm.errors.has('rockArtForm.panelHeight') || _vm.errors.has('rockArtForm.panelWidth'))
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Panel dimensions")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.panelHeight),
      expression: "orientationDto.panelHeight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": "Height",
      "name": "panelHeight"
    },
    domProps: {
      "value": (_vm.orientationDto.panelHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "panelHeight", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.panelWidth),
      expression: "orientationDto.panelWidth"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": "Width",
      "name": "panelWidth"
    },
    domProps: {
      "value": (_vm.orientationDto.panelWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "panelWidth", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.errors.has('rockArtForm.panelHeight') || _vm.errors.has('rockArtForm.panelWidth'))),
      expression: "(errors.has('rockArtForm.panelHeight') || errors.has('rockArtForm.panelWidth'))"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'panelHeight',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': (_vm.errors.has('rockArtForm.panelDistance') || _vm.errors.has('rockArtForm.panelDegree'))
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Site Datum to Panel Datum")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.panelDistance),
      expression: "orientationDto.panelDistance"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": "meters",
      "name": "panelDistance"
    },
    domProps: {
      "value": (_vm.orientationDto.panelDistance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "panelDistance", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.panelDegree),
      expression: "orientationDto.panelDegree"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "degrees east of north",
      "name": "panelDegree"
    },
    domProps: {
      "value": (_vm.orientationDto.panelDegree)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orientationDto, "panelDegree", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.errors.has('rockArtForm.panelDistance') || _vm.errors.has('rockArtForm.panelDegree'))),
      expression: "(errors.has('rockArtForm.panelDistance') || errors.has('rockArtForm.panelDegree'))"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'panelDistance',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.archeologicalDeposits')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Associated/nearby archaeological deposits")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orientationDto.yesNoArcheologicalDepositsId),
      expression: "orientationDto.yesNoArcheologicalDepositsId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "archeologicalDeposits"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.orientationDto, "yesNoArcheologicalDepositsId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Unknown")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.archeologicalDeposits')),
      expression: "errors.has('rockArtForm.archeologicalDeposits')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.archeologicalDeposits')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'yesNoArcheologicalDepositsId',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.culturalAffiliation')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Cultural/Stylistic Affiliation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styleDto.culturalAffiliationId),
      expression: "styleDto.culturalAffiliationId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "culturalAffiliation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.styleDto, "culturalAffiliationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.culturalAffiliationList), function(culture) {
    return _c('option', {
      domProps: {
        "value": culture.culturalAffiliationId
      }
    }, [_vm._v("\n                            " + _vm._s(culture.description) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.culturalAffiliation')),
      expression: "errors.has('rockArtForm.culturalAffiliation')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.culturalAffiliation')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'culturalAffiliationId',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.culturalAffiliationDesc')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Specific affiliation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styleDto.culturalAffiliationDesc),
      expression: "styleDto.culturalAffiliationDesc"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "culturalAffiliationDesc"
    },
    domProps: {
      "value": (_vm.styleDto.culturalAffiliationDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.styleDto, "culturalAffiliationDesc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.culturalAffiliationDesc')),
      expression: "errors.has('rockArtForm.culturalAffiliationDesc')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.culturalAffiliationDesc')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._m(10), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'culturalAffiliationDesc',
      "hasAppend": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Figure manufacture attributes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedStyleList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.styleTypeMap), function(t) {
    return _c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedStyleList),
        expression: "selectedStyleList"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + t.field
      },
      domProps: {
        "value": t.field,
        "checked": Array.isArray(_vm.selectedStyleList) ? _vm._i(_vm.selectedStyleList, t.field) > -1 : (_vm.selectedStyleList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedStyleList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t.field,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedStyleList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedStyleList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedStyleList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + t.field
      }
    }, [_vm._v(_vm._s(t.description))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.styleComments')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styleDto.styleComments),
      expression: "styleDto.styleComments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "styleComments"
    },
    domProps: {
      "value": (_vm.styleDto.styleComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.styleDto, "styleComments", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.styleComments')),
      expression: "errors.has('rockArtForm.styleComments')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.styleComments')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'styleComments',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("General Classification")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'panelClassificationList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('checkBoxPanel', {
    ref: "anthropomorphCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.panelSymbolList.filter(function (x) {
        return x.isAnthropomorph
      }),
      "fieldName": 'panelSymbolId',
      "name": _vm.qaqcFieldId + 'anthropomorphCB'
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('checkBoxPanel', {
    ref: "zoomorphCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.panelSymbolList.filter(function (x) {
        return x.isZoomorph
      }),
      "fieldName": 'panelSymbolId',
      "name": _vm.qaqcFieldId + 'zoomorphCB'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.abstractSymbol),
      expression: "abstractSymbol"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.qaqcFieldId + 'isAbstractCB'
    },
    domProps: {
      "checked": Array.isArray(_vm.abstractSymbol) ? _vm._i(_vm.abstractSymbol, null) > -1 : (_vm.abstractSymbol)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.abstractSymbol,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.abstractSymbol = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.abstractSymbol = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.abstractSymbol = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.qaqcFieldId + 'isAbstractCB'
    }
  }, [_vm._v("Abstracts/Symbols")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameDatesSymbol),
      expression: "nameDatesSymbol"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.qaqcFieldId + 'isNameDateCB'
    },
    domProps: {
      "checked": Array.isArray(_vm.nameDatesSymbol) ? _vm._i(_vm.nameDatesSymbol, null) > -1 : (_vm.nameDatesSymbol)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.nameDatesSymbol,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.nameDatesSymbol = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.nameDatesSymbol = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.nameDatesSymbol = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.qaqcFieldId + 'isNameDateCB'
    }
  }, [_vm._v("Names/Initials/Dates")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.keywords')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Keywords")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rockArtPanelDto.keywords),
      expression: "rockArtPanelDto.keywords"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "keywords"
    },
    domProps: {
      "value": (_vm.rockArtPanelDto.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rockArtPanelDto, "keywords", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.keywords')),
      expression: "errors.has('rockArtForm.keywords')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.keywords')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'keywords',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.detailedDescription')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Description of panel")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'detailedDescription',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rockArtPanelDto.detailedDescription),
      expression: "rockArtPanelDto.detailedDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "name": "detailedDescription"
    },
    domProps: {
      "value": (_vm.rockArtPanelDto.detailedDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rockArtPanelDto, "detailedDescription", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.detailedDescription')),
      expression: "errors.has('rockArtForm.detailedDescription')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.detailedDescription')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Background")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedBackgroundList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.backgroundMap), function(b) {
    return _c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedBackgroundList),
        expression: "selectedBackgroundList"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + b.field
      },
      domProps: {
        "value": b.field,
        "checked": Array.isArray(_vm.selectedBackgroundList) ? _vm._i(_vm.selectedBackgroundList, b.field) > -1 : (_vm.selectedBackgroundList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedBackgroundList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = b.field,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedBackgroundList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedBackgroundList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedBackgroundList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + b.field
      }
    }, [_vm._v(_vm._s(b.description))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Rock Feature incorporation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(13), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'featureIncorporation',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rockArtPanelDto.featureIncorporation),
      expression: "rockArtPanelDto.featureIncorporation"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.rockArtPanelDto.featureIncorporation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rockArtPanelDto, "featureIncorporation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rockArtForm.evidenceComment')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Chronological evidence")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedDatingEvidenceList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.datingEvidenceMap), function(d) {
    return _c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDatingEvidenceList),
        expression: "selectedDatingEvidenceList"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + d.field
      },
      domProps: {
        "value": d.field,
        "checked": Array.isArray(_vm.selectedDatingEvidenceList) ? _vm._i(_vm.selectedDatingEvidenceList, d.field) > -1 : (_vm.selectedDatingEvidenceList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedDatingEvidenceList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = d.field,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedDatingEvidenceList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedDatingEvidenceList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedDatingEvidenceList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + d.field
      }
    }, [_vm._v(_vm._s(d.description))])])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datingEvidenceDto.evidenceComment),
      expression: "datingEvidenceDto.evidenceComment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Describe",
      "name": "evidenceComment"
    },
    domProps: {
      "value": (_vm.datingEvidenceDto.evidenceComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.datingEvidenceDto, "evidenceComment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rockArtForm.evidenceComment')),
      expression: "errors.has('rockArtForm.evidenceComment')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rockArtForm.evidenceComment')))])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Panel Condition")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedConditionList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.conditionMap), function(c) {
    return _c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedConditionList),
        expression: "selectedConditionList"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + c.field + 'c'
      },
      domProps: {
        "value": c.field,
        "checked": Array.isArray(_vm.selectedConditionList) ? _vm._i(_vm.selectedConditionList, c.field) > -1 : (_vm.selectedConditionList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedConditionList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = c.field,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedConditionList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedConditionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedConditionList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + c.field + 'c'
      }
    }, [_vm._v(_vm._s(c.description))])])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rockArtPanelDto.conditionDescription),
      expression: "rockArtPanelDto.conditionDescription"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Describe"
    },
    domProps: {
      "value": (_vm.rockArtPanelDto.conditionDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rockArtPanelDto, "conditionDescription", $event.target.value)
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Concerns/Recommendations")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(14), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'preservationConcerns',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rockArtPanelDto.preservationConcerns),
      expression: "rockArtPanelDto.preservationConcerns"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.rockArtPanelDto.preservationConcerns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rockArtPanelDto, "preservationConcerns", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Lighting")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(15), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'lightingCondition',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rockArtPanelDto.lightingCondition),
      expression: "rockArtPanelDto.lightingCondition"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rockArtPanelDto.lightingCondition)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rockArtPanelDto, "lightingCondition", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Recordings completed")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedRecordingList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.recordingMap), function(r) {
    return _c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRecordingList),
        expression: "selectedRecordingList"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + r.field
      },
      domProps: {
        "value": r.field,
        "checked": Array.isArray(_vm.selectedRecordingList) ? _vm._i(_vm.selectedRecordingList, r.field) > -1 : (_vm.selectedRecordingList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedRecordingList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = r.field,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedRecordingList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedRecordingList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedRecordingList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + r.field
      }
    }, [_vm._v(_vm._s(r.description))])])
  })], 2)]), _vm._v(" "), (!_vm.qaqcEnabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("File Attachments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(16), _vm._v(" "), _c('tbody', _vm._l((_vm.mediaList), function(mediaItem) {
    return _c('tr', [_c('td', [(mediaItem.mediaId) ? _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "fa fa-cloud-download",
      staticStyle: {
        "font-size": "18px"
      },
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.mediaDownloadRow(mediaItem)
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mediaItem.file ? mediaItem.file.name : mediaItem.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mediaItem.comment))])])
  }))])])]) : _vm._e(), _vm._v(" "), (!(_vm.formDisabled || _vm.qaqcEnabled)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3 col-md-offset-2"
  }, [_c('input', {
    ref: "newFile",
    staticClass: "form-control",
    attrs: {
      "name": "newFile",
      "type": "file"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageComment),
      expression: "imageComment"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.imageComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageComment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-1",
    on: {
      "click": _vm.addRockArtFile
    }
  }, [_vm._v("Add")])]) : _vm._e()])], 1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.currentPanelNumber === 1
    },
    on: {
      "click": _vm.previousArtPanel
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), (!(_vm.formDisabled)) ? _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.formDisabled
    },
    on: {
      "click": function($event) {
        _vm.qaqcEnabled ? _vm.completeSection('rockArt') : _vm.saveArtPanel()
      }
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.dtoIsNew || _vm.currentPanelNumber >= _vm.rockArtCount
    },
    on: {
      "click": _vm.nextPanel
    }
  }, [_vm._v("Next")])])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'rockArt',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Height of art element(s) from present ground level (in meters)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Lowest")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Highest")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Height")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Width")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Meters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Degrees")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Specific cultural affiliation if known (e.g., Basque)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Anthropomorphs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Zoomorphs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Describe natural rock feature incorporation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("PRESERVATION CONCERNS AND CONSERVATION RECOMMENDATIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Best lighting conditions to view panel, if known")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Download")]), _vm._v(" "), _c('th', [_vm._v("File Name")]), _vm._v(" "), _c('th', [_vm._v("Comment")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261d3545"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/RockArtForm.vue
// module id = 911
// module chunks = 1